import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import Backend from "i18next-http-backend";
import LanguageDetector from "i18next-browser-languagedetector";

const DOCUMENT_LOCALES = {
  en: "en-US",
  es: "es-ES",
  pt: "pt-PT",
};

const syncDocumentLocale = (language) => {
  const baseLanguage = (language || "en").split("-")[0].toLowerCase();
  document.documentElement.lang = DOCUMENT_LOCALES[baseLanguage] || language || "en-US";
};

i18n.on("languageChanged", syncDocumentLocale);

i18n
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  .use(LanguageDetector)
  .use(Backend)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    debug: false,
    fallbackLng: "en",
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
    react: {
      useSuspense: false, // set to false to avoid suspense fallback
    },
  });

syncDocumentLocale(i18n.resolvedLanguage || i18n.language);

export default i18n;
